import React from "react";

import { Box, BoxProps } from "@chakra-ui/react";

export type TextWrapperProps = BoxProps & { "data-testid"?: string };

export function TextWrapper({ children, ...props }: TextWrapperProps) {
  return (
    <Box as="span" {...props}>
      {children}
    </Box>
  );
}

type ChunkTransformer = (chunks: React.ReactNode[]) => React.ReactElement;

export function transformChunks(
  config: Record<string, TextWrapperProps>,
): Record<string, ChunkTransformer> {
  const transformerMap: Record<string, ChunkTransformer> = {};
  Object.keys(config).forEach((chunk) => {
    transformerMap[chunk] = (chunks: React.ReactNode[]) =>
      TextWrapper({
        children: chunks,
        ...config[chunk],
      });
  });
  return transformerMap;
}
